import React from 'react';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export interface PaymentQuickFiltersProps {
  activeFilter: string;
  onFilterChange: (filter: string) => void;
  dateRange: string;
  onDateRangeChange: (range: string) => void;
}

const FILTER_OPTIONS = ['all', 'pending', 'paid', 'overdue', 'flagged'] as const;

export const PaymentQuickFilters: React.FC<PaymentQuickFiltersProps> = ({
  activeFilter,
  onFilterChange,
  dateRange,
  onDateRangeChange,
}) => {
  return (
    <div className="flex items-center space-x-4">
      <div className="flex items-center space-x-2">
        {FILTER_OPTIONS.map((filter) => {
          const isActive = activeFilter === filter;
          return (
            <Button
              key={filter}
              type="button"
              size="sm"
              onClick={() => onFilterChange(filter)}
              className={
                (isActive
                  ? "whitespace-nowrap bg-purple-600 text-white font-medium rounded-lg active:bg-purple-600 focus:bg-purple-600 focus:text-white active:text-white"
                  : "whitespace-nowrap bg-gray-100 text-black hover:bg-gray-200 font-medium rounded-lg active:bg-gray-200 focus:bg-gray-100"
                ) + " flex items-center transition-colors"
              }
            >
              {filter.charAt(0).toUpperCase() + filter.slice(1).replace('-', ' ')}
            </Button>
          );
        })}
      </div>
      <Select value={dateRange} onValueChange={onDateRangeChange}>
        <SelectTrigger className="w-40">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="this-week">This Week</SelectItem>
          <SelectItem value="this-month">This Month</SelectItem>
          <SelectItem value="last-30-days">Last 30 Days</SelectItem>
          <SelectItem value="custom">Custom Range</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default PaymentQuickFilters;
